<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 md10 offset-md1>
        <div id="auditTable" class="table">
          <v-data-iterator :items="formattedRecords" :total-items="totalRecords"
                           :pagination="pagination" @update:pagination="setPagination"
                           :actions-top="true" :rows-per-page-items="rowsPerPageItems"
                           content-class="audit-records-container">
            <!-- Extra div required due to first element in iterator not being correctly scoped
                 for CSS -->
            <div slot="actions" class="push-left">
              <v-btn icon @click="filterModal = true">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </div>
            <div slot="prepend" class="table-row">
              <v-layout row>
                <v-flex xs3>Time</v-flex>
                <v-flex xs3>User</v-flex>
                <v-flex xs3>Record type</v-flex>
                <v-flex xs3>Record Id</v-flex>
              </v-layout>
            </div>
            <div slot="item" slot-scope="record">
              <div class="table-row highlightOnHover" @click="toggleChanges(record.index)">
                <v-layout row>
                  <v-flex xs3>
                    {{ record.item.dateTimeString }}
                  </v-flex>
                  <v-flex xs3>
                    <router-link :to="`/users/${record.item.userId}`">
                      {{ record.item.userName }}
                    </router-link>
                  </v-flex>
                  <v-flex xs3>
                    {{ record.item.recordType }}
                  </v-flex>
                  <v-flex xs3>
                    <router-link
                      :to="`${collectionUrl[record.item.recordType]}${record.item.recordId}`">
                      {{ record.item.recordId }}
                    </router-link>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap v-if="record.index === openRecord">
                          <v-flex xs12 lg6 v-for="change in record.item.fieldChanges"
                                  :key="change.fieldName">
                            <div :class="`field-${change.changeType.toLowerCase()}`">
                              {{ change.fieldName }}: {{ change.oldValue }} -> {{ change.newValue }}
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-else>
                          <v-flex xs12>
                            {{ record.item.changeString }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <div slot="no-data" class="table-row">
              <div v-if="loading">
                Loading...
              </div>
              <div v-else>
                No logs
              </div>
            </div>
            <div slot="no-results" class="table-row">
              <div v-if="loading">
                Loading...
              </div>
              <div v-else>
                No logs
              </div>
            </div>
          </v-data-iterator>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="filterModal">
      <v-card>
        <v-card-text>
          <filter-form @input="filterModal = false" :record-types="Object.keys(collectionUrl)"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import FilterForm from './FilterForm';

  export default {
    components: { FilterForm },
    data() {
      return {
        rowsPerPageItems: [
          10,
          25,
          50,
          { text: 'All', value: -1 }
        ],
        filterModal: false,
        showDatePicker: -1,
        openRecord: -1,
        collectionUrl: {
          users: '/users/',
          groups: '/groups/',
          issued_jwts: '/tokens/',
          approval_flows: '/approvals/flows/',
          approval_requests: '/approvals/requests/'
        }
      };
    },
    computed: {
      formattedRecords() {
        return this.records.map((record) => {
          if (this.users == null) {
            return [];
          }

          let changeString = record.fieldChanges.map((c) => c.fieldName).join(', ');
          if (changeString.length > 100) {
            changeString = changeString.substr(0, 97) + '...';
          }

          return Object.assign(record, {
            dateTimeString: new Date(record.changeDateTime).toLocaleString('en-AU'),
            changeString,
            userName: this.users[record.userId]
          });
        });
      },
      users() {
        const users = {};
        this.$store.state.users.users.forEach((user) => {
          users[user.aoid] = user.name;
        });
        return users;
      },
      usersList() {
        if (!this.users) {
          return [];
        }

        return Object.keys(this.users).map((key) => {
          return {
            label: this.users[key],
            value: key
          };
        });
      },
      ...mapState('audit', [
        'pagination',
        'loading',
        'records',
        'totalRecords'
      ])
    },
    methods: {
      toggleChanges(i) {
        if (getSelection().type === 'Range') {
          return;
        }

        this.openRecord = this.openRecord === i ? -1 : i;
      },
      ...mapActions('audit', [
        'setPagination'
      ]),
      ...mapActions('users', {
        initializeUsers: 'initialize'
      })
    },
    mounted() {
      this.initializeUsers().catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style lang="less">
  @import "../../style/variables.less";

  @border-color: #e6e6e6;

  #auditTable {
    text-align: left;
    overflow: auto;

    .audit-records-container, .table-row {
      min-width: 750px;
    }

    .push-left {
      margin-right: auto;
    }

    .table-row {
      padding: 24px;
      border: 0 solid @border-color;
      border-top-width: 1px;

      &.highlightOnHover {
        cursor: default;
        // Duplicated from Vuetify material theme
        transition: background-color 0.3s cubic-bezier(.25, .8, .50, 1);

        &:hover {
          background-color: #efefef;
        }
      }

      .v-card {
        margin-top: 10px;

        [class|="field"] {
          padding: 1px 5px;
        }
        .field-create {
          color: @edval-green;
        }
        .field-change {
          color: @edval-light;
        }
        .field-delete {
          color: @edval-red;
        }
      }
    }
  }
</style>
